import React from 'react'
import { useTranslate } from 'react-admin'
import { productStatusChoices } from 'services/cfg/form'
import { isSectionValid } from '../../utils'
import CustomReferenceInput from 'ui-shared/CustomInputs/CustomReferenceInput'
import ProfessionalServiceSelectionInput from 'ui-shared/FormComponents/ProfessionalServiceSelectionInput'
import useSelections from '../hooks/useSelections'
import KFormTab from 'ui-shared/WrappedInputs/KFormTab'
import { Badge } from '@mui/material'
import { ProfessionalSection } from 'services/api/entities/catalog/sections/professionalSections'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const ProfessionalsTab: React.FC = (props) => {
  const { hasSelections } = useSelections('professionals')
  const translate = useTranslate()

  return (
    <KFormTab
      {...props}
      label={
        <Badge
          badgeContent={hasSelections ? 1 : 0}
          color="primary"
          variant="dot"
        >
          {translate('form.tabs.professionals')}
        </Badge>
      }
    >
      <KSelectInput
        source="professionalStatus"
        label="form.fields.status"
        choices={productStatusChoices}
        defaultValue={productStatusChoices[0].id}
      />

      {/* Professionals input */}
      <CustomReferenceInput<ProfessionalSection>
        entity="professionalsections"
        filterFns={[isSectionValid]}
      >
        <ProfessionalServiceSelectionInput />
      </CustomReferenceInput>
    </KFormTab>
  )
}

export default ProfessionalsTab
